import React from "react";
import { Dropdown } from "primereact/dropdown";

interface DropdownProps {
  style?: React.CSSProperties;
  sectionClass?: string;
  className?: string;
  id: string;
  label?: string;
  validation?: any;
  options: any[];
  modelValue: any;
  optionLabel?: string;
  optionValue?: string;
  placeholder?: string;
  disabled?: boolean;
  showClear?: boolean;

  onUpdateModelValue: (value: any) => void;
}

const DropdownComponent: React.FC<DropdownProps> = ({
  style,
  className,
  sectionClass = "field",
  id,
  label,
  validation,
  options,
  modelValue,
  optionLabel = "name",
  optionValue = "id",
  placeholder,
  disabled = false,
  onUpdateModelValue,
  showClear = false,
}) => {
  const handleDropdownChange = (event: { value: any }) => {
    onUpdateModelValue(event.value);
  };

  return (
    <div className={`${sectionClass} ${!label ? "mb-0" : ""}`}>
      <label htmlFor={id} className={`form-label ${!label ? "hidden" : ""} `}>
        {label}
      </label>
      <Dropdown
        id={id}
        value={modelValue}
        options={options}
        optionLabel={optionLabel}
        optionValue={optionValue}
        disabled={disabled}
        placeholder={placeholder}
        className={validation?.$error ? "p-invalid" : ""}
        aria-describedby={`${id}-help`}
        onChange={handleDropdownChange}
        filter
        filterBy={optionLabel}
        showClear={showClear}
      />
      {validation?.$error &&
        validation.required &&
        validation.required.$invalid && (
          <span id={`${id}-help`} className="p-error text-left mt-2">
            {validation.required.$message}
          </span>
        )}
    </div>
  );
};

export default DropdownComponent;
